/* eslint-disable */
export const IS_BROWSER = typeof window !== 'undefined';

let languageState = {
    languageCode: 'en',
    messages: {}
};

export const setLanguageState = (state) => {
    languageState = state;
};

export const retrieveStringValue = (...args) => {
    const { length } = args;
    let nestedObj = languageState.messages;
    if (length === 1) {
        return nestedObj[args[0]] || args[0];
    }
    for (let i = 0; i < length; i += 1) {
        if (i === length - 1) {
            return nestedObj;
        }
        if (nestedObj && nestedObj[args[i]]) {
            nestedObj = nestedObj[args[i]];
        } else {
            return args[length - 1];
        }
    }
    return null;
};

export const createLocaleConstantFromObject = (constant, translateKeys) => {
    if (translateKeys.length < 1) {
        return constant;
    }
    return () =>
        (() => {
            const localizedConstant = {};
            const constantKeys = Object.keys(constant);
            constantKeys.forEach((key) => {
                const newObj = { ...constant[key] };
                translateKeys.forEach((translateProperties) => {
                    const newLabel = newObj[translateProperties.property].replace(/\s+/g, '');
                    newObj[translateProperties.property] = retrieveStringValue(
                        `${translateProperties.keyPreface}_${newLabel}`,
                        newObj[translateProperties.property]
                    );
                });
                localizedConstant[key] = newObj;
            });
            return localizedConstant;
        })();
};

const _createLocaleConstantFromArray = (constant, translateKeys) => () =>
    (() => {
        const localizedConstant = [];
        constant.forEach((constantItem) => {
            const newObj = { ...constantItem };
            translateKeys.forEach((translateProperties) => {
                const newLabel = newObj[translateProperties.property].replace(/\s+/g, '');
                newObj[translateProperties.property] = retrieveStringValue(
                    `${translateProperties.keyPreface}_${newLabel}`,
                    newObj[translateProperties.property]
                );
            });
            localizedConstant.push(newObj);
        });
        return localizedConstant;
    })();

export const capitalizeExceptForArticles = (string) => {
    const articles = [
        'A',
        'An',
        'The',
        'And',
        'Of',
        'But',
        'Or',
        'For',
        'Nor',
        'With',
        'On',
        'At',
        'To',
        'From',
        'By',
        'Is'
    ];
    return string.replace(/\w\S*/g, (txt) => {
        const capitalized = txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        if (articles.indexOf(capitalized) > -1) {
            return txt.toLocaleLowerCase();
        }
        return capitalized;
    });
};

export const videoAndAudioFiles = ['.mov', '.mp4', '.flv', '.avi', '.wmv', '.mp3', '.wav', '.wma', '.aac', '.flac'];

export const ActionKeys = [
    'GET_OBJECT_VOTE_COUNTS',

    // Learning Frameworks
    'GET_LEARNING_FRAMEWORK',
    'GET_MANY_LEARNING_FRAMEWORKS',
    'PUT_LEARNING_FRAMEWORK_START',
    'PUT_LEARNING_FRAMEWORK_SUCCESS',
    'POST_LEARNING_FRAMEWORK_START',
    'POST_LEARNING_FRAMEWORK_SUCCESS',

    // Asset Review Items
    'GET_ASSET_REVIEW_ITEM',
    'GET_MANY_ASSET_REVIEW_ITEMS',
    'PUT_ASSET_REVIEW_ITEM_START',
    'PUT_ASSET_REVIEW_ITEM_SUCCESS',
    'PUT_MANY_ASSET_REVIEW_ITEM_SUCCESS',
    'POST_ASSET_REVIEW_ITEM_START',
    'POST_ASSET_REVIEW_ITEM_SUCCESS',

    // Miscellaneous
    'GET_VERSION',
    'INVITE_USERS',
    'INVITE_EMPLOYEES',
    'SET_MOBILE_STATUS',
    'UPLOAD_NEW_IMAGE',
    'SHARED',
    'SESSION_START',
    'CLOSE_TAB',
    'BUTTON_CLICK',
    'LINK_CLICK',
    'CHANGE_LANGUAGE',
    'SORT_FIELD',
    'CLEAR_SOURCE',

    // Profiles
    'GET_PROFILE_VOTE',
    'POST_PROFILE_VOTE_START',
    'PUT_PROFILE_VOTE_START',
    'DELETE_PROFILE_VOTE_START',
    'GET_ALL_PROFILE_VOTES',
    'ADD_PROFILE',
    'UPDATE_PROFILE',
    'GET_PROFILE_STARTED',
    'GET_PROFILE',
    'GET_MANY_PROFILES',
    'CLEAR_SEARCHED_PROFILES',
    'GET_FILTERED_PROFILES',
    'POST_SEARCHED_USER_PROFILES',
    'UPDATE_SEARCHED_USER_PROFILES',
    'PUT_PROFILE_COLLECTION',
    'PUT_LAST_SIGN_IN_DATETIME',
    'DELETE_PROFILE',
    'CLEAR_PROFILES',
    'REAL_DELETE_PROFILES',

    // Auth
    'LOGIN_REQUEST',
    'LOGIN_SUCCESS',
    'LOGIN_RENEW_TOKEN',
    'LOGIN_SAS_RENEW_TOKEN',
    'LOGIN_ERROR',
    'LOGOUT',
    'UPDATE_LOGGED_IN_USER',
    'AUTHENTICATE_ONLY',

    // Userfollows
    'GET_USERFOLLOWS_META',
    'GET_FOLLOWERS',
    'GET_FOLLOWING',
    'POST_USERFOLLOW_START',
    'POST_USERFOLLOW',
    'POST_USERFOLLOW_FAILURE',
    'DELETE_USERFOLLOW_START',
    'DELETE_USERFOLLOW',
    'DELETE_USERFOLLOW_FAILURE',

    // Change password
    'CHANGE_PASSWORD_SUCCESS',
    'CHANGE_PASSWORD_ERROR',

    // Favorites
    'GET_FAVORITES',
    'ADD_FAVORITE',
    'ADD_FAVORITE_START',
    'REMOVE_FAVORITE',
    'REALLOW_FAVORITE',
    'REMOVE_FAVORITE_START',
    'GET_FAVORITES_METADATA',

    // Growth Reports
    'GET_GROWTH_REPORT',
    'POST_GROWTH_REPORT_START',
    'POST_GROWTH_REPORT_SUCCESS',
    'PUT_GROWTH_REPORT_START',
    'PUT_GROWTH_REPORT_SUCCESS',
    'GET_MANY_GROWTH_REPORTS',
    'GET_FILTERED_GROWTH_REPORTS',
    'CLEAR_SEARCHED_GROWTH_REPORTS',
    'DELETE_GROWTH_REPORT',

    // Modal
    'SHOW_MODAL',
    'HIDE_MODAL',

    // Companies
    'CLEAR_SEARCHED_COMPANIES',
    'GET_FILTERED_COMPANIES',
    'GET_MANY_COMPANIES',
    'GET_COMPANY',
    'GET_COMPANY_MEMBERS',
    'ADD_COMPANY_MEMBERS_START',
    'ADD_COMPANY_MEMBERS_SUCCESS',
    'REMOVE_COMPANY_MEMBERS_START',
    'REMOVE_COMPANY_MEMBERS_SUCCESS',
    'POST_COMPANY_START',
    'POST_COMPANY_SUCCESS',
    'PUT_COMPANY_START',
    'PUT_COMPANY_SUCCESS',
    'UPDATE_COMPANY_PAYMENT_INFO',

    // Home
    'PUT_HOME_SUCCESS',
    'GET_HOME',

    // Collections
    'GET_MANY_COLLECTIONS',
    'GET_MANY_COLLECTIONS_START',
    'GET_FURTHER_LEARNING_COLLECTIONS',
    'GET_FURTHER_LEARNING_COLLECTIONS_START',
    'GET_FILTERED_COLLECTIONS',
    'GET_COLLECTION',
    'POST_COLLECTION_START',
    'POST_COLLECTION_SUCCESS',
    'PUT_COLLECTION_START',
    'PUT_COLLECTION_SUCCESS',
    'CLEAR_SEARCHED_COLLECTIONS',
    'PUT_ARCHIVED_COLLECTION_SUCCESS',
    'PUT_UNARCHIVED_COLLECTION_SUCCESS',
    'GET_MANY_ARCHIVED_COLLECTIONS',
    'GET_RECOMMENDED_AND_ASSIGNED_COLLECTIONS',

    // USER_COLLECTIONS
    'GET_MANY_USER_COLLECTIONS',
    'GET_MANY_USER_COLLECTIONS_START',
    'GET_USER_COLLECTION_FINISHED',
    'GET_FURTHER_LEARNING_COLLECTIONS_FINISHED',
    'GET_FILTERED_USER_COLLECTIONS',
    'POST_SEARCHED_USER_COLLECTIONS',
    'GET_USER_COLLECTION',
    'GET_USER_COLLECTION_START',
    'POST_USER_COLLECTION_START',
    'POST_USER_COLLECTION_SUCCESS',
    'PUT_USER_COLLECTION_START',
    'PUT_USER_COLLECTION_SUCCESS',
    'PUT_USER_COLLECTION_STATUS',
    'PUT_USER_COLLECTION_CONTENT_START',
    'PUT_USER_COLLECTION_CONTENT_SUCCESS',
    'CLEAR_SEARCHED_USER_COLLECTIONS',
    'REMOVE_USER_COLLECTION',
    'CLEAR_USER_COLLECTIONS',
    'DELETE_USER_COLLECTION_START',
    'DELETE_USER_COLLECTION_SUCCESS',

    // Learning Assets
    'GET_MANY_LEARNING_ASSETS',
    'GET_MANY_LEARNING_ASSETS_START',
    'GET_FILTERED_LEARNING_ASSETS',
    'GET_LEARNING_ASSET',
    'POST_LEARNING_ASSET_START',
    'POST_LEARNING_ASSET_SUCCESS',
    'PUT_LEARNING_ASSET_START',
    'PUT_LEARNING_ASSET_SUCCESS',
    'CLEAR_SEARCHED_LEARNING_ASSETS',
    'PUT_ARCHIVED_LEARNING_ASSET_SUCCESS',
    'PUT_UNARCHIVED_LEARNING_ASSET_SUCCESS',
    'GET_MANY_ARCHIVED_LEARNING_ASSETS',

    // Defaults
    'GET_MANY_SETTINGS',
    'GET_SETTING',
    'POST_SETTING_START',
    'POST_SETTING_SUCCESS',
    'PUT_SETTING_START',
    'PUT_SETTING_SUCCESS',

    // Nav
    'EXPAND_NAVIGATION',
    'COLLAPSE_NAVIGATION',
    'UPDATE_PREVIOUS_LOCATION',
    'RETURN_TO_INFO_SLIDE',

    // Suppression Data
    'GET_SUPPRESSION_DATA',
    'PUT_SUPPRESSION_DATA',

    // Surveys
    'GET_MANY_SURVEYS',
    'GET_SURVEY',
    'POST_SURVEY_START',
    'POST_SURVEY_SUCCESS',
    'PUT_SURVEY_START',
    'PUT_SURVEY_SUCCESS',

    // User Survey Data
    'GET_ALL_USER_SURVEY_DATA',
    'GET_USER_SURVEY_DATA',
    'POST_USER_SURVEY_DATA_START',
    'POST_USER_SURVEY_DATA_SUCCESS',

    // User Events
    'GET_MANY_USER_EVENTS',
    'GET_USER_EVENT',
    'POST_USER_EVENT_START',
    'POST_USER_EVENT_SUCCESS',
    'PUT_USER_EVENT_START',
    'PUT_USER_EVENT_SUCCESS',

    // Files
    'UPLOAD_NEW_FILE',
    'GET_MANY_FILES',

    // UserLearningAssets
    'GET_MANY_USERLEARNINGASSETS',
    'GET_MANY_USERLEARNINGASSETS_START',
    'GET_FILTERED_USERLEARNINGASSETS',
    'POST_SEARCHED_USERLEARNINGASSETS',
    'GET_USERLEARNINGASSET',
    'POST_USERLEARNINGASSET_START',
    'POST_USERLEARNINGASSET_SUCCESS',
    'PUT_USERLEARNINGASSET_START',
    'RESET_USERLEARNINGASSET_START',
    'RESET_USERLEARNINGASSET_SUCCESS',
    'PUT_USERLEARNINGASSET_SUCCESS',
    'PUT_COMPLETEDSECTIONITEMDATA_SUCCESS',
    'CLEAR_SEARCHED_USERLEARNINGASSETS',
    'CREATE_TEMPORARY_USERLEARNINGASSET',
    'REMOVE_TEMPORARY_USERLEARNINGASSET',
    'PUT_USERLEARNINGASSET_METADATA_START',
    'PUT_USERLEARNINGASSET_METADATA_SUCCESS',
    'CLEAR_USERLEARNINGASSETS',
    'GET_INTERSTITIAL_RECOMMENDATION',
    // User Feedback Assets
    'GET_USER_FEEDBACK_ASSET',
    'PUT_USER_FEEDBACK_ASSET_START',
    'PUT_USER_FEEDBACK_ASSET_SUCCESS',

    // Workspace
    'UPDATE_SECTION',
    'GET_SECTIONS',
    'UPDATE_WORKSPACE_ASSET',
    'CLEAR_WORKSPACE_ASSET',
    'PUT_WORKSPACE_ASSET',
    'PUT_WORKSPACE_ASSET_ON_FINAL',
    'UPDATE_WORKSPACE_ASSET_COMPLETED_SECTIONITEMS',
    'UPDATE_WORKSPACE_ASSET_METADATA',
    'SET_WORKSPACE_ACTIVE_SLIDE_NUMBER',

    // notes
    'POST_NOTES',
    'GET_NOTES',

    // Recommendations
    'GET_MANY_RECOMMENDATIONS_LEARNING_ASSETS',
    'GET_MANY_RECOMMENDATIONS_COLLECTIONS',
    'GET_MANY_RECOMMENDATIONS_PATHWAYS',
    'POST_RECOMMENDATIONS',
    'PUT_RECOMMENDATIONS',
    'PUT_MANY_RECOMMENDATIONS',

    // Badges
    'GET_BADGE',
    'GET_MANY_BADGES',
    'POST_BADGE_START',
    'POST_BADGE_SUCCESS',
    'PUT_BADGE_START',
    'PUT_BADGE_SUCCESS',
    'DELETE_BADGE',

    // Coupons
    'GET_COUPON',
    'DELETE_COUPON',
    'GET_MANY_COUPONS',
    'POST_COUPON_SUCCESS',

    // Behaviors
    'GET_BEHAVIOR',
    'GET_MANY_BEHAVIORS',
    'POST_BEHAVIOR_START',
    'POST_BEHAVIOR_SUCCESS',
    'PUT_BEHAVIOR_START',
    'PUT_BEHAVIOR_SUCCESS',

    // Abilities
    'GET_ABILITY',
    'GET_MANY_ABILITIES',
    'POST_ABILITY_START',
    'POST_ABILITY_SUCCESS',
    'PUT_ABILITY_START',
    'PUT_ABILITY_SUCCESS',

    // Dimensions
    'GET_DIMENSION',
    'GET_MANY_DIMENSIONS',
    'POST_DIMENSION_START',
    'POST_DIMENSION_SUCCESS',
    'PUT_DIMENSION_START',
    'PUT_DIMENSION_SUCCESS',
    'GET_EXPLORE_PAGE_DIMENSIONS',

    // Global Section Items
    'GET_GLOBAL_SECTION_ITEM',
    'GET_MANY_GLOBAL_SECTION_ITEMS',
    'GET_FILTERED_GLOBAL_SECTION_ITEMS',
    'POST_SEARCHED_GLOBAL_SECTION_ITEMS',
    'POST_GLOBAL_SECTION_ITEM_START',
    'POST_GLOBAL_SECTION_ITEM_SUCCESS',
    'PUT_GLOBAL_SECTION_ITEM_START',
    'PUT_GLOBAL_SECTION_ITEM_SUCCESS',
    'CLEAR_SEARCHED_GLOBAL_SECTION_ITEMS',

    // Global Content Row Items
    'GET_GLOBAL_CONTENT_ROW',
    'GET_MANY_GLOBAL_CONTENT_ROWS',
    'GET_FILTERED_GLOBAL_CONTENT_ROWS',
    'POST_SEARCHED_GLOBAL_CONTENT_ROWS',
    'POST_GLOBAL_CONTENT_ROW_START',
    'POST_GLOBAL_CONTENT_ROW_SUCCESS',
    'PUT_GLOBAL_CONTENT_ROW_START',
    'PUT_GLOBAL_CONTENT_ROW_SUCCESS',
    'CLEAR_SEARCHED_GLOBAL_CONTENT_ROWS',

    // Bookmarks
    'GET_BOOKMARK',
    'GET_MANY_BOOKMARKS',
    'POST_BOOKMARK',
    'PUT_BOOKMARK',

    // Welcome Assets
    'GET_MANY_WELCOME_ASSETS_START',
    'GET_MANY_WELCOME_ASSETS',
    'GET_WELCOME_ASSET',
    'POST_WELCOME_ASSET_START',
    'POST_WELCOME_ASSET_SUCCESS',
    'PUT_WELCOME_ASSET_START',
    'PUT_WELCOME_ASSET_SUCCESS',

    // User Welcome Assets
    'POST_USER_WELCOME_ASSET_START',
    'POST_USER_WELCOME_ASSET_SUCCESS',
    'GET_ACTIVE_USER_WELCOME_ASSET',

    // Teams
    'GET_MANY_TEAMS',
    'GET_TEAM',
    'GET_TEAM_ADMIN',
    'PUT_TEAM_START',
    'PUT_TEAM_ASSIGNMENT',
    'PUT_TEAMS_LOCAL',
    'PUT_TEAM_SUCCESS',
    'POST_TEAM_START',
    'POST_TEAM_SUCCESS',
    'ADD_TEAM_MEMBERS_START',
    'ADD_TEAM_MEMBERS_SUCCESS',
    'REMOVE_TEAM_MEMBERS_START',
    'REMOVE_TEAM_MEMBERS_SUCCESS',
    'DELETE_TEAM_SUCCESS',
    'SET_UNSAVED_CHANGES',

    // Explore Search
    'ALGOLIA_STATE_INIT',
    'ALGOLIA_SEARCH_START',
    'ALGOLIA_SEARCH_SUCCESS',
    'UPDATE_ALGOLIA_SEARCH_FILTERS',
    'UPDATE_ALGOLIA_SEARCH_INDICES',
    'UPDATE_ALGOLIA_SEARCH_QUERY',

    // Learning Pathways
    'GET_MANY_PATHWAYS_START',
    'GET_MANY_PATHWAYS',
    'GET_PATHWAY',
    'POST_PATHWAY_SUCCESS',
    'PUT_PATHWAY_SUCCESS',
    'CLEAR_SEARCHED_PATHWAYS',
    'GET_FILTERED_PATHWAYS',
    'GET_MANY_ARCHIVED_PATHWAYS',
    'PUT_UNARCHIVED_PATHWAY_SUCCESS',
    'PUT_PATHWAY_START',
    'PUT_ARCHIVED_PATHWAY_SUCCESS',
    'GET_COMPANY_EXCLUSIVEPATHWAYS_SUCCESS',
    'DELETE_PATHWAY_START',
    'DELETE_PATHWAY_SUCCESS',

    // User Pathways
    'GET_MANY_USER_PATHWAYS_START',
    'GET_MANY_USER_PATHWAYS_SUCCESS',
    'GET_USER_PATHWAY_SUCCESS',
    'POST_USER_PATHWAY_SUCCESS',
    'PUT_USER_PATHWAY_SUCCESS',
    'PREDICT_COMPLETED_USERCOLLECTIONS',
    'PREDICT_COMPLETED_USERPATHWAYS',
    'CLEAR_ALGOLIA_SEARCH_RESULT',
    'DELETE_USER_PATHWAY_SUCCESS',
    'DELETE_USER_PATHWAY_START',
    'CLEAR_SEARCHED_USER_PATHWAYS',
    'POST_SEARCHED_USER_PATHWAYS',

    // User Responses
    'POST_USER_RESPONSE',
    'PUT_USER_RESPONSE_START',
    'PUT_USER_RESPONSE',

    // Local Storage
    'SET_LOCAL_STORAGE',
    'GET_LOCAL_STORAGE',

    // User Feedback
    'POST_USER_FEEDBACK_SUCCESS',
    'GET_MANY_USER_FEEDBACK'
];

export const ACTIONS = (() =>
    ActionKeys.reduce((acc, key) => {
        acc[key] = key;
        return acc;
    }, {}))();

export const SUPPORTED_LANGUAGES = {
    en: {
        languageCode: 'en',
        localeCode: 'en-us',
        languageFile: 'en-us.json',
        label: 'English (USA)'
    },
    ko: {
        languageCode: 'ko',
        localeCode: 'ko-kr',
        languageFile: 'ko-kr.json',
        label: '한국어'
    },
    es: {
        languageCode: 'es',
        localeCode: 'es',
        languageFile: 'es.json',
        label: 'Español'
    },
    pt: {
        languageCode: 'pt',
        localeCode: 'pt-pt',
        languageFile: 'pt-pt.json',
        label: 'Português'
    }
};

export const LANGUAGE_LOCALE_LOOKUP = (() =>
    Object.values(SUPPORTED_LANGUAGES).reduce((acc, lang) => {
        acc[lang.localeCode] = lang;

        return acc;
    }, {}))();

export const MODALS = {
    LOGIN_MODAL: 'LOGIN_MODAL',
    REGISTRATION_MODAL: 'REGISTRATION_MODAL',
    BTN_CLICK_MODAL: 'BTN_CLICK_MODAL',
    PROMPT_MODAL: 'PROMPT_MODAL',
    ONSCREEN_NUDGE_MODAL: 'ONSCREEN_NUDGE_MODAL',
    INVITE_EMPLOYEES: 'INVITE_EMPLOYEES',
    HELP_MODAL: 'HELP_MODAL',
    GROWTH_PDF_MODAL: 'GROWTH_PDF_MODAL',
    PRINT_PREVIEW_MODAL: 'PRINT_PREVIEW_MODAL',
    PRINT_PREVIEW_PROMPTS_MODAL: 'PRINT_PREVIEW_PROMPTS_MODAL',
    TEAM_INVITE_MODAL: 'TEAM_INVITE_MODAL',
    BULK_INVITE_MODAL: 'BULK_INVITE_MODAL'
};

export const CAUSES_OBJECT = (() => {
    const causes = {
        '370dd5a9b4214b0c9bea11f7c315efef': {
            id: '370dd5a9b4214b0c9bea11f7c315efef',
            value: 'education',
            label: 'Education'
        },
        fc832c9c1fcb4fbfa59ba7119662548e: {
            id: 'fc832c9c1fcb4fbfa59ba7119662548e',
            value: 'environment',
            label: 'Environment'
        },
        b5c69cce6e984418a7daccd41e5f6117: {
            id: 'b5c69cce6e984418a7daccd41e5f6117',
            value: 'health',
            label: 'Health and Wellness'
        },
        '4336df62d1a24a36811ae66e2652f02c': {
            id: '4336df62d1a24a36811ae66e2652f02c',
            value: 'poverty',
            label: 'Poverty Alleviation'
        },
        '3ad6ba8d5ee649a8884d44f19f3c6847': {
            id: '3ad6ba8d5ee649a8884d44f19f3c6847',
            value: 'food',
            label: 'Food and Nutrition'
        },
        '303fd044f00a46b3b29d7dc3db687fd4': {
            id: '303fd044f00a46b3b29d7dc3db687fd4',
            value: 'equality',
            label: 'Gender Equality and LGBTQ'
        },
        a50e04a76e6144ebafffa69b3ba03352: {
            id: 'a50e04a76e6144ebafffa69b3ba03352',
            value: 'humanRights',
            label: 'Human Rights'
        },
        ed333e6dc7d6496cb7e411c01f2f3be0: {
            id: 'ed333e6dc7d6496cb7e411c01f2f3be0',
            value: 'animalWelfare',
            label: 'Animal Welfare'
        },
        cb8b470dcef44224a777334c146054db: {
            id: 'cb8b470dcef44224a777334c146054db',
            value: 'civicEngagement',
            label: 'Civic Engagement'
        },
        '3d6b18b8d7814f55818a72ef06807d2f': {
            id: '3d6b18b8d7814f55818a72ef06807d2f',
            value: 'artsAndCulture',
            label: 'Arts and Culture'
        },
        '6f3bf45972e14829b15f3b56b47eae4c': {
            id: '6f3bf45972e14829b15f3b56b47eae4c',
            value: 'futurism',
            label: 'Futurism'
        },
        d7ec4fa2312b4c28a7cc38dccdf256c7: {
            id: 'd7ec4fa2312b4c28a7cc38dccdf256c7',
            value: 'other',
            label: 'Other'
        }
    };
    return createLocaleConstantFromObject(causes, [{ property: 'label', keyPreface: 'CAUSES' }]);
})();

export const CAUSES = () =>
    Object.values(CAUSES_OBJECT()).map((causeObject) => ({
        value: causeObject.value,
        label: causeObject.label
    }));

export const CAUSES_LABEL_LOOKUP = () =>
    Object.values(CAUSES_OBJECT()).reduce((lookup, cause) => {
        lookup[cause.value] = cause.label;
        return lookup;
    }, {});

export const LEARNING_PREFERENCES_OBJECT = (() => {
    const learningPreference = {
        ea140a40d37f499faecf28d8024e21f0: {
            value: 'ea140a40d37f499faecf28d8024e21f0',
            label: 'Read',
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511219/Constants/LearningPreferences/Icon_Read_Active_2.png',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511219/Constants/LearningPreferences/Icon_Read_2.png'
        },
        a399150a54be450ba088864ac9071d43: {
            value: 'a399150a54be450ba088864ac9071d43',
            label: 'Watch',
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503510994/Constants/LearningPreferences/Icon_Watch_Active_2.png',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503510998/Constants/LearningPreferences/Icon_Watch_2.png'
        },
        c518bdfab4be4ebe85c8a32e2543d3d8: {
            value: 'c518bdfab4be4ebe85c8a32e2543d3d8',
            label: 'Solo',
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511220/Constants/LearningPreferences/Icon_Solo_Active_2.png',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511215/Constants/LearningPreferences/Icon_Solo_2.png'
        },
        d2e6efff0ad347a084664f88f1caca22: {
            value: 'd2e6efff0ad347a084664f88f1caca22',
            label: 'Team',
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511220/Constants/LearningPreferences/Icon_Team_Active_2.png',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503511220/Constants/LearningPreferences/Icon_Team_2.png'
        }
    };
    return createLocaleConstantFromObject(learningPreference, [
        { property: 'label', keyPreface: 'LEARNING_PREFERENCES' }
    ]);
})();

export const AVAILABLE_TIME_PREFERENCES_OBJECT = (() => {
    const availableTime = {
        aa543c28ab7d4985b3f5bad48a59daf2: {
            value: 'aa543c28ab7d4985b3f5bad48a59daf2',
            label: '10 min\na day',
            supportedDurations: {
                dd83face710c4c70a5d2ef653c13571a: true,
                f8fc05f4339b43499728617b6df30ac9: true
            },
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503526602/Constants/AvailableTimePreferences/Icon_10Min_active.svg',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503524815/Constants/AvailableTimePreferences/Icon_10Min.svg'
        },
        '39f0c61706354f159c6b71ed075a30b4': {
            value: '39f0c61706354f159c6b71ed075a30b4',
            label: '20 min\na day',
            supportedDurations: {
                ae76f8fc86ff4d3790499383656daf19: true,
                '8e5065313c1342c19ea68db5740583d3': true
            },
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503526602/Constants/AvailableTimePreferences/Icon_20Min_Active.svg',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503524815/Constants/AvailableTimePreferences/Icon_20Min.svg'
        },
        '99a022214d894e84b632b3589c96402d': {
            value: '99a022214d894e84b632b3589c96402d',
            label: '1 hour\nper week',
            supportedDurations: {
                d32490010f24416d9f75b547870b7686: true,
                c7cdeee8eb0a4b4eba9aa6a27bbbd403: true,
                e77ab4fbe1564ced81a5fdbf8993f1c3: true,
                ce1dd636db384021b4a5de11c80d2ca5: true,
                '8284a8c03eb74b39a79f69d5bed4be7b': true
            },
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503526601/Constants/AvailableTimePreferences/Icon_1HourWeekly_Active.svg',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503524815/Constants/AvailableTimePreferences/Icon_1HourWeekly.svg'
        },
        '9da55355cfbd4de3b91f2ddd52d6e099': {
            value: '9da55355cfbd4de3b91f2ddd52d6e099',
            label: '2 hours\nper week',
            supportedDurations: {
                d32490010f24416d9f75b547870b7686: true,
                c7cdeee8eb0a4b4eba9aa6a27bbbd403: true,
                e77ab4fbe1564ced81a5fdbf8993f1c3: true,
                ce1dd636db384021b4a5de11c80d2ca5: true,
                '8284a8c03eb74b39a79f69d5bed4be7b': true,
                '5f1d1ec47b5f4ab199e30b5e614f7796': true,
                c37d1077877949379aa65072121d0dac: true,
                '462f4491a8474064ad379cf560894990': true,
                '4eBqgP0RKccXuIO8B9ngdA5VPosRSTM9': true
            },
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503526602/Constants/AvailableTimePreferences/Icon_2HourWeekly_Active.svg',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503524815/Constants/AvailableTimePreferences/Icon_2HourWeekly.svg'
        },
        f7bbddd8a5264efeb165bc8b8b0904d5: {
            value: 'f7bbddd8a5264efeb165bc8b8b0904d5',
            label: 'Not Sure',
            supportedDurations: {},
            activeImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503526602/Constants/AvailableTimePreferences/Icon_NotSure_Active.svg',
            inactiveImage:
                'http://res.cloudinary.com/verb-prod/image/upload/v1503524815/Constants/AvailableTimePreferences/Icon_NotSure.svg'
        }
    };
    return createLocaleConstantFromObject(availableTime, [
        { property: 'label', keyPreface: 'AVAILABLE_TIME_PREFERENCES' }
    ]);
})();

export const BEHAVIORS = (() => {
    const behaviors = [
        {
            label: 'Have Integrity',
            value: '924f8f8839594244be22701315da2b95'
        },
        {
            label: 'Build Emotional Intelligence',
            value: 'df560d1d12304049be6cd76620dfcbee'
        },
        {
            label: 'Engage Consciously',
            value: '1eeb5649b7044b4a8c8ebbb87d048ede'
        },

        /** New * */
        {
            label: 'Understand Your Influence And Impact',
            value: '5d0862467d4e423bb233d7d161b84f72'
        },
        {
            label: 'Develop A Learning Mindset',
            value: '0f06580e07d4477a9c62ffcf1a3b88a4'
        },
        {
            label: 'Embrace Well Being',
            value: 'ddd6c32ad6ce4de892f837b9d0a5c6af'
        },
        {
            label: 'Choose Optimism',
            value: 'baa2f89f6d4103f295C038e574e7189a'
        },
        {
            label: 'Identify And Develop Talent',
            value: '207ddc7bc91849629f606ad2099cb07e'
        },
        {
            label: 'Retain Talent',
            value: '2adb853a28264f10a4b47ad2ab955ecd'
        },
        {
            label: 'Create Shared Fate',
            value: '6ca623022577434099b35310b19f589d'
        },
        {
            label: 'Achieve Goals',
            value: '7216d08f73da4acf9f307e51524952a8'
        },
        {
            label: 'Create Accountability',
            value: '1003bd8b1bef47d6afe99f6d829897ac'
        },
        {
            label: 'Be Strategic',
            value: 'd20c1e2492ed4e2294cd9b1824d48c9a'
        },
        {
            label: 'Empower Others',
            value: '7f0395381e5f4199a56c190729855e56'
        },
        {
            label: 'Communicate Authentically',
            value: '63989590c8ce4ceca354fd4a70fe96da'
        },
        {
            label: 'Respect Business Partners',
            value: '4847ecfaa15d4adca577c5631ebc9a18'
        },
        {
            label: 'Promote Systems Thinking',
            value: '45aa91f146eb41c29bc9eb3ecf4f7052'
        },
        {
            label: 'Employ Design Thinking',
            value: '0bd440695abd4abbb8f77fab06b2906c'
        },
        {
            label: 'Unlock Creativity',
            value: 'baa2f89f6d4103f295C038e574e0468a'
        },
        {
            label: 'Be Flexible And Adaptable',
            value: 'cca2f89f6d4103f295C038e574e1111a'
        },
        {
            label: 'Chanel Test',
            value: '789bb921c7e14e19b1ae103596eb1c9c'
        }
    ];
    return _createLocaleConstantFromArray(behaviors, [{ property: 'label', keyPreface: 'BEHAVIORS' }]);
})();

export const BEHAVIORS_LOOKUP = () =>
    BEHAVIORS().reduce((prev, behavior) => {
        prev[behavior.value] = behavior;
        return prev;
    }, {});

export const SECTION_ITEM_TYPES = (() => {
    const ONSCREEN_NUDGE = 'Onscreen'.toLocaleUpperCase();
    const EMAIL_NUDGE = 'Email'.toLocaleUpperCase();

    const CHOOSE_ONE_CONTENT = 'Choose One'.toLocaleUpperCase();
    const CHOOSE_ONE_PATH_CONTENT = 'Choose One Path'.toLocaleUpperCase();
    const CHOOSE_MANY_CONTENT = 'Choose Many'.toLocaleUpperCase();
    const CHOOSE_ONE_QUIZ = 'Choose One Quiz'.toLocaleUpperCase();
    const SHORT_ESSAY_CONTENT = 'Short Essay'.toLocaleUpperCase();
    const LIKERT_CONTENT = 'Likert'.toLocaleUpperCase();
    const THIS_OR_THAT_PERMUTATION_CONTENT = 'This or That Permutation'.toLocaleUpperCase();
    const THIS_OR_THAT_RESULTS_CONTENT = 'This or That Results'.toLocaleUpperCase();
    const THIS_OR_THAT_RESULTS_CHART = 'This or That Chart'.toLocaleUpperCase();
    const RANKING_CONTENT = 'Ranking'.toLocaleUpperCase();
    const SURVEY_CONTENT = 'Survey'.toLocaleUpperCase();
    const RICH_TEXT_CONTENT = 'Rich Text'.toLocaleUpperCase();
    const DYNAMIC_RICH_TEXT_CONTENT = 'Dynamic Rich Text'.toLocaleUpperCase();
    const USER_INVITE_CONTENT = 'Invite Users'.toLocaleUpperCase();
    const CHOOSE_ONE_RESULTS_CONTENT = 'Choose One Results'.toLocaleUpperCase();
    const SHORT_ESSAY_RESULT = 'Short Essay Results'.toLocaleUpperCase();
    const FILE_UPLOAD_CONTENT = 'File Upload'.toLocaleUpperCase();
    const QUIZ_RESULTS = 'Quiz Results'.toLocaleUpperCase();
    const SHOW_PREVIOUS_ANSWERS = 'Show Previous Answers'.toLocaleUpperCase();
    const SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE = 'Show Previous Answers and Choose One'.toLocaleUpperCase();
    const FEEDBACK_CONTENT = 'Feedback'.toLocaleUpperCase();
    const FEEDBACK_WRAPUP = 'Feedback WrapUp'.toLocaleUpperCase();
    const FEEDBACK_INVITE = 'Feedback Invite'.toLocaleUpperCase();
    const END_SESSION_CONTENT = 'End Session'.toLocaleUpperCase();
    const REVIEW_PREV_ACTIVITIES = 'Review Previous Activities'.toLocaleUpperCase();
    const WRAP_UP = 'Wrap Up'.toLocaleUpperCase();
    const END_WORKFLOW = 'End Workflow'.toLocaleUpperCase();

    return {
        ONSCREEN_NUDGE,
        EMAIL_NUDGE,
        CHOOSE_ONE_CONTENT,
        CHOOSE_ONE_PATH_CONTENT,
        CHOOSE_MANY_CONTENT,
        CHOOSE_ONE_QUIZ,
        SHORT_ESSAY_CONTENT,
        LIKERT_CONTENT,
        THIS_OR_THAT_PERMUTATION_CONTENT,
        THIS_OR_THAT_RESULTS_CONTENT,
        THIS_OR_THAT_RESULTS_CHART,
        RANKING_CONTENT,
        SURVEY_CONTENT,
        RICH_TEXT_CONTENT,
        DYNAMIC_RICH_TEXT_CONTENT,
        USER_INVITE_CONTENT,
        CHOOSE_ONE_RESULTS_CONTENT,
        SHORT_ESSAY_RESULT,
        FILE_UPLOAD_CONTENT,
        QUIZ_RESULTS,
        SHOW_PREVIOUS_ANSWERS,
        SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE,
        FEEDBACK_CONTENT,
        FEEDBACK_WRAPUP,
        FEEDBACK_INVITE,
        END_SESSION_CONTENT,
        REVIEW_PREV_ACTIVITIES,
        WRAP_UP,
        END_WORKFLOW,

        isNudgeType: (sectionType) => {
            const formattedSectionType = (sectionType || '').toLocaleUpperCase();

            return formattedSectionType === ONSCREEN_NUDGE || formattedSectionType === EMAIL_NUDGE;
        },

        isParticipantSpecific: (sectionItemType) => {
            const formattedSectionType = (sectionItemType || '').toLocaleUpperCase();

            return formattedSectionType === FEEDBACK_INVITE;
        },

        isReadOnly: (sectionItemType) => {
            const formattedSectionType = (sectionItemType || '').toLocaleUpperCase();

            return (
                formattedSectionType === THIS_OR_THAT_RESULTS_CHART ||
                formattedSectionType === THIS_OR_THAT_RESULTS_CONTENT ||
                formattedSectionType === RICH_TEXT_CONTENT ||
                formattedSectionType === DYNAMIC_RICH_TEXT_CONTENT ||
                formattedSectionType === CHOOSE_ONE_RESULTS_CONTENT ||
                formattedSectionType === SHORT_ESSAY_RESULT ||
                formattedSectionType === QUIZ_RESULTS ||
                formattedSectionType === SHOW_PREVIOUS_ANSWERS ||
                formattedSectionType === REVIEW_PREV_ACTIVITIES
            );
        }
    };
})();

const ALL_PARTICIPANT_ROLE = 'all'.toLocaleUpperCase();
const EMPLOYEE_PARTICIPANT_ROLE = 'employee'.toLocaleUpperCase();
const SOCIAL_ENTREPRENEUR_PARTICIPANT_ROLE = 'socialentrepreneur'.toLocaleUpperCase();
const COLLEAGUE_PARTICIPANT_ROLE = 'colleague'.toLocaleUpperCase();
const TEAMMATE_PARTICIPANT_ROLE = 'teammate'.toLocaleUpperCase();
const FACILITATOR_PARTICIPANT_ROLE = 'facilitator'.toLocaleUpperCase();

export const PARTICIPANT_ROLES = {
    ALL: ALL_PARTICIPANT_ROLE,
    EMPLOYEE: EMPLOYEE_PARTICIPANT_ROLE,
    SOCIAL_ENTREPRENEUR: SOCIAL_ENTREPRENEUR_PARTICIPANT_ROLE,
    COLLEAGUE: COLLEAGUE_PARTICIPANT_ROLE,
    TEAMMATE: TEAMMATE_PARTICIPANT_ROLE,
    FACILITATOR: FACILITATOR_PARTICIPANT_ROLE
};

export const MENU_STATUS = [
    {
        label: 'Locked',
        value: 'LOCKED'
    },
    {
        label: 'Unlocked',
        value: 'UNLOCKED'
    },
    {
        label: 'Hidden',
        value: 'HIDDEN'
    }
];

export const MENU_STATUS_OBJECT = (() =>
    MENU_STATUS.reduce((acc, item) => {
        acc[item.value] = item.value;
        return acc;
    }, {}))();

export const DEFAULT_IMAGE_URLS = {
    VERB_LOGO: 'http://res.cloudinary.com/verb-prod/image/upload/v1508338681/logo_scghta.png',
    USER_AVATAR: 'http://res.cloudinary.com/verb-prod/image/upload/v1508268296/verb-avatar-outline-pink-03_bw1uog.png',
    TRACK_THUMBNAIL_IMAGE: 'http://res.cloudinary.com/verb-prod/image/upload/v1497033799/pieqa4lef5uwe20urekf.png',
    LEARNING_ASSET_THUMBNAIL_IMAGE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1580930965/verb-default-collection-thumbnail-001_m79dqn.png',
    TRACK_COVER_IMAGE: 'http://res.cloudinary.com/verb-prod/image/upload/v1497033811/nl2tvd4uvwut8wp0l5hy.png',
    LEARNING_ASSET_COVER_IMAGE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1580930965/verb-default-collection-banner-001_hmllqi.png',
    COLLECTION_BANNER_COVER_IMAGE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1580930965/verb-default-collection-banner-001_hmllqi.png',
    SIO_LOGIN_COVER_IMAGE:
        'http://res.cloudinary.com/verb-prod/image/upload/v1506014212/verb-sio-signup-gradient_uz9q8v.jpg',
    LOGIN_COVER_IMAGE_W_OVERLAY:
        'http://res.cloudinary.com/verb-prod/image/upload/l_v-outline_adjklh,o_25,y_40/v1506014212/verb-sio-signup-gradient_uz9q8v.jpg',
    COMPANY_DEFAULT_COVER_IMAGE:
        'http://res.cloudinary.com/verb-prod/image/upload/v1506366520/verb-company-signup-dark-v2_xonsfg.jpg',
    COMPANY_DEFAULT_THUMBNAIL:
        'https://res.cloudinary.com/verb-prod/image/upload/v1507045086/company_avatar_ggk9xe.png',
    LOCKED_BADGE_IMAGE: '/static/images/Icon_Lock.svg',
    WELCOME_STEP_1: 'https://res.cloudinary.com/verb-prod/image/upload/v1504211423/Step_1_cw1id4.png',
    WELCOME_STEP_2: 'https://res.cloudinary.com/verb-prod/image/upload/v1504211423/Step_2_cvs3q6.png',
    WELCOME_STEP_3: 'https://res.cloudinary.com/verb-prod/image/upload/v1504211423/Step_3_rjb5mc.png',
    WELCOME_STEP_4: 'https://res.cloudinary.com/verb-prod/image/upload/v1504211423/Step_4_wk9hjr.png',
    WELCOME_STEP_5: 'https://res.cloudinary.com/verb-prod/image/upload/v1504211423/Step_5_ujh684.png',
    WELCOME_HOME_PAGE_SPLASH:
        'https://res.cloudinary.com/verb-prod/image/upload/v1504158103/Constants/Welcome_Background.png',
    V_OUTLINE: 'https://res.cloudinary.com/verb-prod/image/upload/v1504158150/Constants/v-outline.png',
    V_WELCOME: 'https://res.cloudinary.com/verb-prod/image/upload/v1526486469/icon_verb-welcome_noxdaa.png',
    TALENT_DASHBOARD: 'https://res.cloudinary.com/verb-prod/image/upload/v1510259023/Verb_Dashboard_1_pm9nx4.png',
    FEEDBACK_FINAL: 'https://res.cloudinary.com/verb-prod/image/upload/v1512407753/Feedback_Final_Party_xgnkav.png',
    CERTIFICATE_BLANK:
        'https://res.cloudinary.com/verb-prod/image/upload/v1599147714/Verb_Certificate_of_Completion_x7kkae.png',
    CERTIFICATE_BLANK_PATHWAY:
        'https://res.cloudinary.com/verb-prod/image/upload/v1638291399/Verb_Certificate_of_Completion_Pathway_mt1val.png',
    RECOMMENDATION_IMAGE: 'https://res.cloudinary.com/verb-prod/image/upload/v1559683230/recommendation_gift.gif',
    TEAM_INVITE_IMAGE: 'https://res.cloudinary.com/verb-prod/image/upload/v1580853965/invite_thumbnail.png',
    LEARNING_PATHWAY_IMAGE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1609739216/Pathways_ScratchPad_V3_ChoosePathway_ir5zri.png',
    LEARNING_PATHWAY_HERBIE_FLAG:
        'https://res.cloudinary.com/verb-prod/image/upload/v1592841974/Pathways_FlagHerbie_ykflom.png',
    LEARNING_PATHWAY_FLAG_FILLED:
        'https://res.cloudinary.com/verb-prod/image/upload/v1600269974/Constants/Pathways_ScratchPad_V3_FlagFilled_qa86my.png',
    LEARNING_PATHWAY_FLAG:
        'https://res.cloudinary.com/verb-prod/image/upload/v1600269969/Constants/Pathways_ScratchPad_V3_Flag_flaxuh.png',
    LEARNING_PATHWAY_TENT:
        'https://res.cloudinary.com/verb-prod/image/upload/v1600269960/Constants/EventIcon01_pcuhhj.png',
    PATHWAY_EVENT_FLAG: 'https://res.cloudinary.com/verb-prod/image/upload/v1600086213/PathwayEventIcon_qu6jpc.png',
    PATHWAY_EVENT_THUMBNAIL_GREY:
        'https://res.cloudinary.com/verb-prod/image/upload/v1600086213/PathwayEventThumbnailGrey_kmbhwr.png',
    PATHWAY_EVENT_THUMBNAIL:
        'https://res.cloudinary.com/verb-prod/image/upload/v1600086213/PathwayEventThumbnail_ghucvv.png',
    PATHWAY_TASK_INCOMPLETE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1610625356/Pathways_ScratchPad_V3_task_incomplete_inlvax.png',
    PATHWAY_TASK_COMPLETE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1610625356/Pathways_ScratchPad_V3_task_complete_gyasij.png',
    PATHWAY_TASK_THUMBNAIL:
        'https://res.cloudinary.com/verb-prod/image/upload/v1610625356/Pathways_ScratchPad_V3_TaskThumbnail_01_j78ldg.png',
    SLACK_LOGO_WHITE:
        'https://res.cloudinary.com/verb-prod/image/upload/v1626058351/Slack_Mark_Monochrome_White_w9shdg.png',
    SLACK_LOGO_WHITE_SVG:
        'https://res.cloudinary.com/verb-prod/image/upload/v1626061846/Slack_Mark_Monochrome_White_kdzuwv.svg',
    SLACK_LOGO_COLOR: 'https://res.cloudinary.com/verb-prod/image/upload/v1626058351/Slack_Mark_Web_pkwldd.png',
    SLACK_LOGO_COLOR_SVG: 'https://res.cloudinary.com/verb-prod/image/upload/v1626061947/Slack_Mark_uj5ttu.svg',
    VERB_V_PINK: 'https://res.cloudinary.com/verb-prod/image/upload/v1694008226/PaycorLogo_tfuqhv.png'
};

export const LEARNING_ASSET_TYPE_OBJECT = {
    ACTIVITY: {
        id: 'ACTIVITY',
        label: 'Interactive',
        label_plural: 'Activities',
        label_hover: 'Interactive'
    },
    SINGLE_PAGE_ACTIVITY: {
        id: 'SINGLE_PAGE_ACTIVITY',
        label: 'Interactive',
        label_plural: 'Activities',
        label_hover: 'Interactive'
    },
    ARTICLE: {
        id: 'ARTICLE',
        label: 'Article',
        label_plural: 'Articles',
        label_hover: 'Article'
    },
    ASSESSMENT: {
        id: 'ASSESSMENT',
        label: 'Assessment',
        label_plural: 'Assessments',
        label_hover: 'Assessment'
    },
    PRE_ASSESSMENT: {
        id: 'PRE_ASSESSMENT',
        label: 'Pre-Assessment',
        label_plural: 'Pre Assessments',
        label_hover: 'Pre-Assessment'
    },
    POST_ASSESSMENT: {
        id: 'POST_ASSESSMENT',
        label: 'Post-Assessment',
        label_plural: 'Post Assessments',
        label_hover: 'Post-Assessment'
    },
    IMPACT_PROJECT: {
        id: 'IMPACT_PROJECT',
        label: 'Impact Project',
        label_plural: 'Impact Projects',
        label_hover: 'Impact Project'
    },
    VIDEO: {
        id: 'VIDEO',
        label: 'Video',
        label_plural: 'Videos',
        label_hover: 'Video'
    },
    AUDIO: {
        id: 'AUDIO',
        label: 'Audio',
        label_plural: 'Audio',
        label_hover: 'Audio'
    },
    TRACK: {
        id: 'TRACK',
        label: 'Course',
        label_plural: 'Courses',
        label_hover: 'Course'
    },
    FEEDBACK: {
        id: 'FEEDBACK',
        label: 'Feedback',
        label_plural: 'Feedback',
        label_hover: 'Feedback'
    },
    WELCOME: {
        id: 'WELCOME',
        label: 'Welcome Asset',
        label_plural: 'Welcome Assets',
        label_hover: 'Welcome Asset'
    },
    MOBILE: {
        id: 'MOBILE',
        label: 'Mobile Asset',
        label_plural: 'Mobile Assets',
        label_hover: 'Mobile Asset'
    },
    PRACTICAL_APPLICATION: {
        id: 'PRACTICAL_APPLICATION',
        label: 'Practical Application',
        label_plural: 'Practical Application Assets',
        label_hover: 'Take Actions',
        explore_label: 'Take Action and Reflect'
    },
    REFLECTION: {
        id: 'REFLECTION',
        label: 'Reflection',
        label_plural: 'Reflection Assets',
        label_hover: 'Reflect'
    }
};

export const TYPE_OPTIONS = [
    { label: 'No Label', value: 'NO_LABEL' },
    { label: 'Article', value: 'ARTICLE' },
    { label: 'Video', value: 'VIDEO' },
    { label: 'Audio', value: 'AUDIO' }
];

export const TYPE_OPTIONS_LIST = (typeLabel) => {
    return (TYPE_OPTIONS.filter(({ value }) => value === typeLabel)[0] || {}).value || '';
};

export const TYPE_LABELS = () => TYPE_OPTIONS.map(({ value }) => value);

export const ASSET_TYPE_ICONS = {
    ACTIVITY: 'fa-pencil-alt',
    ARTICLE: 'fa-newspaper',
    SINGLE_PAGE_ACTIVITY: 'fa-pencil-alt',
    ASSESSMENT: 'fa-file-edit',
    PRE_ASSESSMENT: 'fa-map-signs',
    POST_ASSESSMENT: 'fa-graduation-cap',
    COURSE: 'fa-book',
    VIDEO: 'fa-film',
    IMPACT_PROJECT: 'fa-heart',
    TRACK: 'fa-pen-square',
    PODCAST: 'fa-microphone-alt',
    FEEDBACK: 'fa-bullhorn',
    WELCOME: 'fa-anchor',
    AUDIO: 'fa-microphone-alt',
    PRACTICAL_APPLICATION: 'fa-comments-alt',
    REFLECTION: 'fa-brain'
};

export const SSO_OPTIONS = [
    { label: 'None', value: null },
    { label: 'SSO', value: 'SSO' },
    { label: 'SSO with Alternative Login', value: 'SSO_ALT' }
];

export const USER_RESPONSE_TYPES = {
    CONTENT_RELEVANCY: 'CONTENT_RELEVANCY',
};

export const USER_RESPONSE_PARENT_TYPES = {
    ACTIVITY_WRAP_UP: 'ACTIVITY_WRAP_UP'
};

export const REFERENCE_FILE_TYPE_ICONS = (file = '') => {
    const fileType = file.split('.').pop();
    if (['doc', 'docx', 'txt', 'rtf'].includes(fileType.toLowerCase())) {
        return 'fa-file-alt text-file';
    }
    if (['png', 'jpg', 'bmp', 'gif', 'svg'].includes(fileType.toLowerCase())) {
        return 'fa-file-image image-file';
    }
    if (['mp3'].includes(fileType.toLowerCase())) {
        return 'fa-file-audio audio-file';
    }
    if (['csv'].includes(fileType.toLowerCase())) {
        return 'fa-file-csv csv-file';
    }
    if (['xlsx', 'xls'].includes(fileType.toLowerCase())) {
        return 'fa-file-spreadsheet spreadsheet-file';
    }
    if (['pdf'].includes(fileType.toLowerCase())) {
        return 'fa-file-pdf pdf-file';
    }
    if (['pptx', 'ppt'].includes(fileType.toLowerCase())) {
        return 'fa-file-powerpoint powerpoint-file';
    }
    if (['mp4', 'mov'].includes(fileType.toLowerCase())) {
        return 'fa-file-video video-file';
    }
    return 'fa-file default-file';
};

/**
 *
 * @type {{ACTIVITY: string, ARTICLE: string, ASSESSMENT: string, IMPACT_PROJECT: string, VIDEO: string, TRACK: string, FEEDBACK: string}}
 */
export const LEARNING_ASSET_TYPES = (() =>
    Object.values(LEARNING_ASSET_TYPE_OBJECT).reduce((acc, obj) => {
        acc[obj.id] = obj.id;
        return acc;
    }, {}))();

export const LEARNING_ASSET_LABELS = () =>
    Object.values(LEARNING_ASSET_TYPE_OBJECT).reduce((acc, obj) => {
        acc[obj.id] = retrieveStringValue(`LEARNING_ASSET_LABEL_${obj.id.toLocaleLowerCase()}`, obj.label);
        return acc;
    }, {});

export const LEARNING_ASSET_TYPES_V2 = () =>
    Object.values(LEARNING_ASSET_TYPE_OBJECT).reduce((acc, obj) => {
        acc[obj.id] = {
            value: obj.id,
            label: retrieveStringValue(`LEARNING_ASSET_LABEL_${obj.id.toLocaleLowerCase()}`, obj.label)
        };
        return acc;
    }, {});

export const LEARNING_ASSET_DURATIONS = (() => {
    const learningAssetDurations = {
        dd83face710c4c70a5d2ef653c13571a: {
            value: 'dd83face710c4c70a5d2ef653c13571a',
            label: '< 5 minutes',
            inMinutes: 5
        },
        f8fc05f4339b43499728617b6df30ac9: {
            value: 'f8fc05f4339b43499728617b6df30ac9',
            label: '10 minutes',
            inMinutes: 10
        },
        ae76f8fc86ff4d3790499383656daf19: {
            value: 'ae76f8fc86ff4d3790499383656daf19',
            label: '15 minutes',
            inMinutes: 15
        },
        xieagqkrw9015fv0x7cllziv8e9rglk9: {
            value: 'xieagqkrw9015fv0x7cllziv8e9rglk9',
            label: '20 minutes',
            inMinutes: 20
        },
        '8e5065313c1342c19ea68db5740583d3': {
            value: '8e5065313c1342c19ea68db5740583d3',
            label: '30 minutes',
            inMinutes: 30
        },
        d32490010f24416d9f75b547870b7686: {
            value: 'd32490010f24416d9f75b547870b7686',
            label: '1 hour',
            inMinutes: 60
        },
        c7cdeee8eb0a4b4eba9aa6a27bbbd403: {
            value: 'c7cdeee8eb0a4b4eba9aa6a27bbbd403',
            label: '2 hours',
            inMinutes: 120
        },
        e77ab4fbe1564ced81a5fdbf8993f1c3: {
            value: 'e77ab4fbe1564ced81a5fdbf8993f1c3',
            label: '3 hours',
            inMinutes: 180
        },
        ce1dd636db384021b4a5de11c80d2ca5: {
            value: 'ce1dd636db384021b4a5de11c80d2ca5',
            label: '4 hours',
            inMinutes: 240
        },
        '8284a8c03eb74b39a79f69d5bed4be7b': {
            value: '8284a8c03eb74b39a79f69d5bed4be7b',
            label: '5 hours',
            inMinutes: 300
        },
        '5f1d1ec47b5f4ab199e30b5e614f7796': {
            value: '5f1d1ec47b5f4ab199e30b5e614f7796',
            label: '6 hours',
            inMinutes: 360
        },
        c37d1077877949379aa65072121d0dac: {
            value: 'c37d1077877949379aa65072121d0dac',
            label: '7 hours',
            inMinutes: 420
        },
        '462f4491a8474064ad379cf560894990': {
            value: '462f4491a8474064ad379cf560894990',
            label: '8 hours',
            inMinutes: 480
        },

        '4eBqgP0RKccXuIO8B9ngdA5VPosRSTM9': {
            value: '4eBqgP0RKccXuIO8B9ngdA5VPosRSTM9',
            label: '9 hours',
            inMinutes: 540
        },

        '63BqgP0RKccXuIOU92ngdA5VPosGITM9': {
            value: '63BqgP0RKccXuIOU92ngdA5VPosGITM9',
            label: '10 hours',
            inMinutes: 600
        },

        '63BqgP0RKccXuIO8B9ngdA5VPoaKyTM9': {
            value: '63BqgP0RKccXuIO8B9ngdA5VPoaKyTM9',
            label: '11 hours',
            inMinutes: 660
        },

        '78uqgP0RKccXuIO8B9ngdA5VPosGITM9': {
            value: '78uqgP0RKccXuIO8B9ngdA5VPosGITM9',
            label: '12 hours',
            inMinutes: 720
        },

        '63Bq8730KccXuIO8B9ngdA5VPosGITM9': {
            value: '63Bq8730KccXuIO8B9ngdA5VPosGITM9',
            label: '13 hours',
            inMinutes: 780
        },

        '63BqgP0RKccXuIO8lG8wdA5VPosGITM9': {
            value: '63BqgP0RKccXuIO8lG8wdA5VPosGITM9',
            label: '14 hours',
            inMinutes: 840
        },
        '6925e85a089e4b8ab110315f858567fd': {
            value: '6925e85a089e4b8ab110315f858567fd',
            label: 'Self Paced',
            inMinutes: 0
        }
    };
    return createLocaleConstantFromObject(learningAssetDurations, [
        { property: 'label', keyPreface: 'LEARNING_ASSET_DURATIONS' }
    ]);
})();

export const LEARNING_ASSET_CATEGORIES = (() => {
    const assetCategory = {
        '34855167d72243f3b507910fe6ea1473': {
            value: '34855167d72243f3b507910fe6ea1473',
            label: 'Leadership'
        },
        '4c2063e5f74943908858d58093188942': {
            value: '4c2063e5f74943908858d58093188942',
            label: 'Strategy'
        },
        b456b52956104c8a95b8aef3c90de9c3: {
            value: 'b456b52956104c8a95b8aef3c90de9c3',
            label: 'Innovation'
        }
    };
    return createLocaleConstantFromObject(assetCategory, [
        { property: 'label', keyPreface: 'LEARNING_ASSET_CATEGORIES' }
    ]);
})();

export const LEARNING_ASSET_CATEGORIES_BY_NAME = {
    LEADERSHIP: '34855167d72243f3b507910fe6ea1473',
    STRATEGY: '4c2063e5f74943908858d58093188942',
    INNOVATION: 'b456b52956104c8a95b8aef3c90de9c3'
};

export const LEARNING_ASSET_CATEGORIES_BY_BEHAVIOR = (() => {
    const assetCategoryByBehavior = {
        '924f8f8839594244be22701315da2b95': {
            label: 'Communication',
            category: 'Leadership'
        },
        '1eeb5649b7044b4a8c8ebbb87d048ede': {
            label: 'Problem Solving',
            category: 'Leadership'
        },
        df560d1d12304049be6cd76620dfcbee: {
            label: 'Grit and Resilience',
            category: 'Leadership'
        },
        '5d0862467d4e423bb233d7d161b84f72': {
            label: 'Goal Setting',
            category: 'Leadership'
        },
        ddd6c32ad6ce4de892f837b9d0a5c6af: {
            label: 'Collaboration',
            category: 'Leadership'
        },

        '207ddc7bc91849629f606ad2099cb07e': {
            label: 'Analytical Thinking',
            category: 'Strategy'
        },
        '2adb853a28264f10a4b47ad2ab955ecd': {
            label: 'Decision Making',
            category: 'Strategy'
        },
        '6ca623022577434099b35310b19f589d': {
            label: 'Business Strategy',
            category: 'Strategy'
        },
        '7216d08f73da4acf9f307e51524952a8': {
            label: 'Lean Startup',
            category: 'Strategy'
        },
        '1003bd8b1bef47d6afe99f6d829897ac': {
            label: 'Pitching Ideas',
            category: 'Strategy'
        },
        baa2f89f6d4103f295C038e574e0468a: {
            label: 'Business Acumen',
            category: 'Strategy'
        },

        d20c1e2492ed4e2294cd9b1824d48c9a: {
            label: 'Design Thinking',
            category: 'Innovation'
        },
        '7f0395381e5f4199a56c190729855e56': {
            label: 'Innovation Culture',
            category: 'Innovation'
        },
        '63989590c8ce4ceca354fd4a70fe96da': {
            label: 'Empathy',
            category: 'Innovation'
        },
        '4847ecfaa15d4adca577c5631ebc9a18': {
            label: 'Brainstorming',
            category: 'Innovation'
        },
        '45aa91f146eb41c29bc9eb3ecf4f7052': {
            label: 'Story Telling',
            category: 'Innovation'
        },
        '0bd440695abd4abbb8f77fab06b2906c': {
            label: 'Visual Communication',
            category: 'Innovation'
        }
    };

    // Add categoryId onto value for quicker lookup
    Object.keys(assetCategoryByBehavior).forEach((behaviorId) => {
        if (assetCategoryByBehavior[behaviorId].category === 'Leadership') {
            assetCategoryByBehavior[behaviorId].categoryId = LEARNING_ASSET_CATEGORIES_BY_NAME.LEADERSHIP;
        } else if (assetCategoryByBehavior[behaviorId].category === 'Innovation') {
            assetCategoryByBehavior[behaviorId].categoryId = LEARNING_ASSET_CATEGORIES_BY_NAME.INNOVATION;
        } else if (assetCategoryByBehavior[behaviorId].category === 'Strategy') {
            assetCategoryByBehavior[behaviorId].categoryId = LEARNING_ASSET_CATEGORIES_BY_NAME.STRATEGY;
        }
    });

    return createLocaleConstantFromObject(assetCategoryByBehavior, [
        { property: 'label', keyPreface: 'BEHAVIORS' },
        { property: 'category', keyPreface: 'LEARNING_ASSET_CATEGORIES' }
    ]);
})();

export const LICENSE_TYPES = (() => {
    const NOT_AVAILABLE = 'NotAvailable';
    const NOT_AVAILABLE_UPPER = NOT_AVAILABLE.toLocaleUpperCase();
    const AVAILABLE_FOR_ALL = 'AvailableForAll';
    const AVAILABLE_FOR_ALL_UPPER = AVAILABLE_FOR_ALL.toLocaleUpperCase();
    const EXCLUSIVE_COMPANY_LICENSE = 'ExclusiveCompanyLicense';
    const EXCLUSIVE_COMPANY_LICENSE_UPPER = EXCLUSIVE_COMPANY_LICENSE.toLocaleUpperCase();

    return {
        NOT_AVAILABLE,
        NOT_AVAILABLE_UPPER,
        AVAILABLE_FOR_ALL,
        AVAILABLE_FOR_ALL_UPPER,
        EXCLUSIVE_COMPANY_LICENSE,
        EXCLUSIVE_COMPANY_LICENSE_UPPER
    };
})();

export const RECOMMENDED_PACES = (() => {
    const TWO_HOURS_A_MONTH = '2 hours a month';
    const TWO_HOURS_A_MONTH_UPPER = TWO_HOURS_A_MONTH.toLocaleUpperCase();
    const ONE_HOUR_A_MONTH = '1 hour a month';
    const ONE_HOUR_A_MONTH_UPPER = ONE_HOUR_A_MONTH.toLocaleUpperCase();
    const ONE_HOUR_A_WEEK = '1 hour a week';
    const ONE_HOUR_A_WEEK_UPPER = ONE_HOUR_A_WEEK.toLocaleUpperCase();

    return {
        TWO_HOURS_A_MONTH,
        TWO_HOURS_A_MONTH_UPPER,
        ONE_HOUR_A_MONTH,
        ONE_HOUR_A_MONTH_UPPER,
        ONE_HOUR_A_WEEK,
        ONE_HOUR_A_WEEK_UPPER
    };
})();

export const PROMPT_TYPES = (() => {
    const SHOWN_TO_ALL = 'SHOWN_TO_ALL';
    const SHOWN_TO_MANAGERS = 'SHOWN_TO_MANAGERS';

    return {
        SHOWN_TO_ALL,
        SHOWN_TO_MANAGERS
    };
})();

export const DEFAULT_DISCUSSION_PROMPTS = (() => {
    return {
        prompts: [
            {
                value: 'What is your biggest takeaway from this collection, and why?',
                showOption: PROMPT_TYPES.SHOWN_TO_ALL
            },
            {
                value: 'What did you apply or put into action from this collection?',
                showOption: PROMPT_TYPES.SHOWN_TO_ALL
            },
            { value: 'What insights do you have from your experience?', showOption: PROMPT_TYPES.SHOWN_TO_ALL }
        ],
        name: 'General Discussion Prompts'
    };
})();

export const COLLECTION_TYPES = (() => {
    const STANDARD = 'STANDARD';
    const MINI = 'MINI';
    const COLLAB = 'COLLAB';

    return {
        STANDARD,
        MINI,
        COLLAB
    };
})();

export const CREATED_BY_TYPES = (() => {
    const BY_VERB = 'CREATED_BY_VERB';
    const BY_CUSTOMER = 'CREATED_BY_CUSTOMER';
    const BY_THIRD_PARTY = 'CREATED_BY_THIRD_PARTY';

    return {
        BY_VERB,
        BY_CUSTOMER,
        BY_THIRD_PARTY
    };
})();

export const ROUTE_PREFIXES = {
    DISCOVER: '/discover',
    HOME: '/home',
    CONTENT_FRAMEWORK: '/contentframework',
    MEASURE: '/measure',
    MY_COLLECTIONS: '/explore/mycollections',
    COLLECTION_DETAILS: '/collection',
    EXPLORE: '/explore',
    WORKSPACE: '/workspace',
    WELCOME: '/welcome',
    NEW_WELCOME_ASSET: '/newwelcomeasset',
    EDIT_WELCOME_ASSET: '/editwelcomeasset',
    USERCOLLECTIONS: '/mycollection',
    LEARNING_SAMPLER: '/learningsampler',
    TEAMS: '/teams',
    PROFILE_BOOKMARK: '/bookmarks',
    ADMIN: '/admin',
};

export const ADMIN_ROUTE_PREFIXES = {
    ADMINISTRATION: '/administration',
    ANALYTICS: '/analytics',
    CONTENT: '/content',
    SUBSCRIPTIONS: '/subscriptions'
};

export const SEGMENT_EVENTS = {
    AUTH0_TOKEN_REFRESH: 'Auth0 Token Refresh',
    BOOKMARK_REFERENCE: 'Navigation: Reference Bookmarks',
    COLLECTION_CERTIFICATE_DOWNLOAD: 'Collection Page: Download Certificate',
    COLLECTION_REFERENCE_GUIDE_DOWNLOAD: 'Collection Page: Download Reference Guide',
    COLLECTION_INTERSTITIAL_UP_NEXT: 'Collection Interstitial: Keep Learning',
    COLLECTION_INTERSTITIAL_UP_NEXT_MILESTONE_EVENT: 'Collection Interstitial: See My Pathway',
    COLLECTION_INTERSTITIAL_RECOMMEND: 'Collection Interstitial: Recommend',
    COLLECTION_INTERSTITIAL_CERTIFICATE_DOWNLOAD: 'Collection Interstitial: Download Certificate',
    COLLECTION_INTERSTITIAL_REFERENCE_DOWNLOAD: 'Collection Interstitial: Download Reference Sheet',
    COLLECTION_REFERENCE_DOWNLOAD: 'Collection Page: Download Reference Sheet',
    COLLECTION_START: 'Collection Start',
    COLLECTION_SUBSCRIPTION: 'Collection Subscribe',
    COLLECTION_DIRECT_LINK_FROM_COMPANY: 'Collection Embeded by Company',
    COLLECTION_COMPLETED: 'Collection Completed',
    COMPANY_INVITE_REMINDER: 'Company Employees: Company Invite Nudge',
    CONTENT_RELEVANCY_ANSWERED: 'Content Relevancy Answered',
    HOME_BROWSE_COLLECTIONS: 'Home: Browse Collections',
    HOME_FEATURED_COLLECTION: 'Home Page: Featured Collection',
    HOME_CALL_TO_ACTION: 'Home Page: Call to Action Click',
    HOME_CLOSE_COMPANY_ANNOUNCEMENT: 'Home: Close Company Announcement',
    INTERSTITIAL_MONTHLY_RECOMMEND: 'Monthly Recommend Modal: Send Recommendation',
    INTERSTITIAL_RECOMMEND: 'Learning Asset Interstitial: Recommend',
    INTERSTITIAL_NEXT_ASSET: 'Learning Asset Interstitial: Next Asset',
    LEARNING_ASSET_BEGIN: 'Learning Asset: Begin',
    LEARNING_ASSET_BOOKMARK: 'Learning Asset: Bookmark',
    LEARNING_ASSET_DONE: 'Learning Asset: Done',
    LEARNING_ASSET_NEXT: 'Learning Asset: Next',
    LEARNING_ASSET_SEARCH: 'Search: Learning Asset',
    MY_COLLETION_TRACK_GROWTH_CERTIFICATE_DOWNLOAD: 'My Collection - Track Growth: Download Certificate',
    MY_COLLETION_TRACK_GROWTH_REFERENCE_DOWNLOAD: 'My Collection - Track Growth: Download Reference Sheet',
    MY_COLLECTION_TRACK_DISCUSSION_PROMPTS_DOWNLOAD: 'My Collection - Track Discussion: Download Discussion Prompts',
    NAV_ACT: 'Navigation: Act',
    NAV_ADMINISTRATION: 'Navigation: Administration',
    NAV_BOOKMARKS: 'Navigation: Profile - Bookmarks Tab',
    NAV_COLLABORATE: 'Navigation: Collaborate',
    NAV_CONTENT: 'Navigation: Content',
    NAV_EXPLORE_LIBRARY: 'Navigation: Explore - Library',
    NAV_EXPLORE_SEARCH: 'Navigation: Explore - Search',
    NAV_EXPLORE_MY_COLLECTIONS: 'Navigation: Explore - My Collections',
    NAV_DISCOVER: 'Navigation: Discover',
    NAV_MEASURE_CSV_DOWNLOADS: 'Navigation: Measure - CSV Downloads',
    NAV_MEASURE_ENGAGEMENT_SUMMARY: 'Navigation: Measure - Engagement Summary',
    NAV_MEASURE_REPORTS: 'Navigation: Measure - Reports',
    NAV_MEASURE_FACEBOOK_DATA_REPORT: 'Navigation: Measure - Facebook Data Report',
    NAV_MEASURE_GROWTH_SUMMARY: 'Navigation: Measure - Growth Summary',
    NAV_MEASURE_LEARNING_SUMMARY: 'Navigation: Measure - Learning Summary',
    NAV_MEASURE_TALENT_DETAILS: 'Navigation: Measure - Talent Details',
    NAV_MY_COLLECTION_TRACK_GROWTH: 'Navigation: My Collection - Track Growth',
    NAV_MY_COLLECTION_TRACK_DISCUSSION: 'Navigation: My Collection - Track Discussion',
    NAV_MY_COLLECTION_REFERENCE: 'Navigation: My Collection - Reference Guide',
    NAV_MY_COLLECTION_REFERENCE_GUIDE_MODAL: 'Navigation: My Collection - Reference Guide Modal',
    NAV_NOTIFICATION: 'Navigation: Notification',
    NAV_PROFILE: 'Navigation: Profile',
    NAV_SETTINGS: 'Navigation: Settings',
    NAV_PROFILE_BOOKMARK_TAB: 'Navigation: Profile Bookmarks tab',
    NAV_PROFILE_GROWTH_TAB: 'Navigation: Profile Growth tab',
    NAV_PROFILE_LEARNING_TIMELINE_TAB: 'Navigation: Profile Learning Timeline tab',
    NAV_SUBSCRIPTIONS: 'Navigation: User Subscriptions',
    NAV_TEAMS: 'Navigation: Teams',
    NAV_VERB_LOGO: 'Navigation: Paths Logo',
    SAS_TOKEN_REFRESH: 'SAS Token Refresh',
    TERMS_AGREEMENT: 'Terms Agreement',
    TERMS_SECOND_DISAGREE: 'Terms Second Disagree',
    USER_LOG_IN: 'Log In',
    USER_SIGN_UP: 'Sign Up',
    LEARNING_STREAM_ASSET: 'Learning Stream - Go to listed learning asset',
    LEARNING_STREAM_COLLECTION: 'Learning Stream - Go to listed collection',
    LIBRARY_SEARCH_SUBMIT: 'New Search: Submit Search',
    LIBRARY_LEARNING_ASSET_CLICK: 'New Search: Click learning asset',
    LIBRARY_COLLECTION_CLICK: 'New Search: Click collection',
    PROFILE_GROWTH_PDF_DOWNLOAD: 'Profile: Growth PDF Download',
    TEAMS_REFERENCE_FILE_DOWNLOAD: 'Team: Download File',
    TEAMS_INVITE_START: 'Team: Invite Start',
    TEAMS_INVITE_DONE: 'Team: Invite Done',
    TEAMS_PERMALINK_COPIED: 'Team: Invite Permalink Copied',
    TEAMS_ACTIVITY_REACTION_ADDED: 'Team: Activity Reaction Added',
    TEAMS_ACTIVITY_REACTION_DELETED: 'Team: Activity Reaction Deleted',
    TEAMS_ACTIVITY_COMMENT: 'Team: Activity Comment',
    TEAMS_ANNOUNCEMENT_START: 'Team: Announcement Begin',
    TEAMS_ANNOUNCEMENT_DONE: 'Team: Announcement Done',
    TEAMS_RECOMMEND_START: 'Team: Recommend Begin',
    TEAMS_RECOMMEND_DONE: 'Team: Recommend Done',
    TEAMS_INVITE_REMINDER: 'Team: Teams Invite Nudge',
    TEAMS_FEATURE_COLLECTION: 'Team: Featured Collection',
    TEAMS_UNFEATURE_COLLECTION: 'Team: Unfeatured Collection',
    TEAMS_ASSIGN_COLLECTION: 'Team: Assign Collection',
    TEAMS_UNASSIGN_COLLECTION: 'Team: Unassign Collection',
    TEAMS_HOME_CARD_CLICK: 'Home: Team Card',
    HOME_TEAM_BANNER_CLICK: 'Home: Team Banner Click',
    OPEN_WORKSPACE_BEGIN: 'Workspace Open: Begin',
    OPEN_WORKSPACE_NEXT: 'Workspace Open: Next',
    OPEN_WORKSPACE_DONE: 'Workspace Open: Done',
    REFERENCE_FILE_DOWNLOAD: 'Download File',
    PATHWAY_VIEW_DETAILS: 'Pathway: View Pathway Details',
    PATHWAY_VIEW_MORE_PATHWAYS: 'Pathway: View More Pathways',
    PATHWAY_GIVE_PATHWAY_FEEDBACK: 'Pathway: Give Pathway Feedback',
    PATHWAY_SUBSCRIPTION: 'Pathway: Subscription',
    PATHWAY_EXIT_PATHWAY_DETAILS: 'Pathway: Exit Pathway Details',
    PATHWAY_START_PATHWAY: 'Pathway: Start Pathway',
    PATHWAY_CONTINUE_PATHWAY: 'Pathway: Continue Pathway',
    PATHWAY_VIEW_COLLECTION: 'Pathway: View Collection',
    PATHWAY_INTERSTITIAL_CERTIFICATE_DOWNLOAD: 'Pathway Interstitial: Download Certificate',
    PATHWAY_INTERSTITIAL_RECOMMEND: 'Pathway Interstitial: Recommend Pathway',
    PATHWAY_INTERSTITIAL_UP_NEXT: 'Pathway Interstitial: Next Pathway',
    PATHWAY_VIEW_EVENT: 'Pathway: View Event',
    PATHWAY_VIEW_TASK_URL: 'Pathway: View Task Url',
    PATHWAY_COMPLETE_TASK_CHECK: 'Pathway: Complete Task Click',
    SHORT_ESSAY_ANSWERED: 'Short Essay Answered',
    WORKSPACE_MEDIA_LIBRARY_RESOURCE_CLICK: 'Workspace: Click Media Library Resource',
    ENGAGEMENT_DASHBOARD: 'Measure: Engagement Dashboard',
    PATHWAY_DRILL_DOWN: 'Measure: Pathway Drill Down',
    COLLECTION_DRILL_DOWN: 'Measure: Collection Drill Down',
    ACTIVITY_DRILL_DOWN: 'Measure: Activity Drill Down',
    LEARNER_DRILL_DOWN: 'Measure: Learner Drill Down',
    TALENT_DETAILS: 'Measure: Talent Details',
    GROWTH_SUMMARY: 'Measure: Growth Summary',
    CSV_DOWNLOAD_REPORTS: 'Measure: CSV Download Reports',
    CONTENT_PATHWAY_COPY: 'Pathway: Copy Pathway',
    ARCHIVE_PATHWAY: 'Pathway: Archive Pathway',
    EDIT_PATHWAY: 'Pathway: Edit Pathway',
    UNARCHIVE_PATHWAY: 'Pathway: Unarchive Pathway',
    LEARNER_MILESTONE_STATUS_CHANGE: 'Admin Pathway: Change Learner Milestone Status',
    LEARNER_ACTIVITY_STATUS_CHANGE_COLLECTION: 'Admin Collection: Change Learner Activity Status',
    LEARNER_ACTIVITY_STATUS_CHANGE: 'Admin Activity: Change Learner Activity Status',
    CSV_DOWNLOAD_PROGRAM_STATUS: 'Measure: CSV Download Program Status',
    PATHS_BOT: 'Paths AI Assistant'
};

export const CORRECT_ANSWER_FEEDBACK = (() => {
    const answerFeedback = ['Nice job!', 'Awesome!', 'Good choice!', 'Well done!', 'Excellent!', 'Way to go!'];
    return () =>
        (() => {
            const localizedConstant = [];
            answerFeedback.forEach((string) => {
                const constantKey = string.replace(/\W+/g, '').slice();
                localizedConstant.push(retrieveStringValue(`CORRECT_ANSWER_FEEDBACK_${constantKey}`, string));
            });
            return localizedConstant;
        })();
})();

export const INCORRECT_ANSWER_FEEDBACK = (() => {
    const answerFeedback = [
        'Uh oh!',
        "Oops. This isn't the correct answer.",
        'Uh oh, this is not the correct answer.',
        "Oh no! This isn't the correct choice."
    ];

    return () =>
        (() => {
            const localizedConstant = [];
            answerFeedback.forEach((string) => {
                const constantKey = string.replace(/\W+/g, '').slice(0, 10);
                localizedConstant.push(retrieveStringValue(`INCORRECT_ANSWER_FEEDBACK_${constantKey}`, string));
            });
            return localizedConstant;
        })();
})();

export const RICH_TEXT_LAYOUTS = (() =>
    [
        'TOP_TEXT_ONLY',
        'TOP_TEXT_BOTTOM_IMAGE',
        'LEFT_TEXT_RIGHT_IMAGE',
        'RIGHT_TEXT_LEFT_IMAGE',
        'TEXT_SIDE_BY_SIDE',
        'TOP_TEXT_BOTTOM_VIDEO',
        'TOP_TEXT_BOTTOM_AUDIO',
        'CENTERED_TEXT'
    ].reduce((acc, curr) => {
        acc[curr] = curr;

        return acc;
    }, {}))();

export const SLACK_IMAGE_SRC = 'https://platform.slack-edge.com/img/add_to_slack.png';

export const SLACK_IMAGE_SRCSET =
    'https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x';

export const AUTH_PERMISSION_ROLES = {
    VerbAdmin: 'isVerbAdmin',
    ContentReviewer: 'isContentReviewer',
    ContentAuthor: 'isContentAuthor',
    ContentAdmin: 'isContentAdmin',
    TeamAdmin: 'isTeamAdmin',
    AccountOwner: 'isAccountOwner',
    TeamReportViewer: 'isTeamReportViewer',
    CompanyReportViewer: 'isCompanyReportViewer',
    VerbReportViewer: 'isVerbReportViewer',
    ReportViewer: 'isCompanyReportViewer',
    InstructionalAdmin: 'isInstructionalAdmin',
    InstructionalContentAdmin: 'isInstructionalContentAdmin',
    InstructionalReportViewer: 'isInstructionalReportViewer',
};

export const BROWSER_IMAGES = {
    firefox: 'https://res.cloudinary.com/verb-prod/image/upload/v1548191800/Firefox_Logo__2017_m7d8n1.svg',
    chrome:
        'https://res.cloudinary.com/verb-prod/image/upload/v1548191804/Google_Chrome_icon__September_2014_hrwr03.svg'
};

export const ASSET_METADATA_CATEGORIES = {
    '7c834864-1f46-4155-b289-0010ed5232f0': {
        id: '7c834864-1f46-4155-b289-0010ed5232f0',
        label: 'Role'
    },
    '2d136189-cd34-48b3-be00-8f4c96d4e966': {
        id: '2d136189-cd34-48b3-be00-8f4c96d4e966',
        label: 'Experience'
    },
    '08636b4a-ff37-4b01-8af3-17e68ebd7be2': {
        id: '08636b4a-ff37-4b01-8af3-17e68ebd7be2',
        label: 'Goals'
    }
};

export const ASSET_METADATA_LOOKUP = {
    // ROLES
    'a84dbc2a-d70e-47a7-a9eb-fe738f231962': {
        id: 'a84dbc2a-d70e-47a7-a9eb-fe738f231962',
        label: 'Individual Contributor',
        categoryId: '7c834864-1f46-4155-b289-0010ed5232f0'
    },
    '15258edb-6825-4a16-8049-bc7c9e63ba67': {
        id: '15258edb-6825-4a16-8049-bc7c9e63ba67',
        label: 'Manager',
        categoryId: '7c834864-1f46-4155-b289-0010ed5232f0'
    },
    'b03363df-35f6-4146-904a-b61fcd7729f2': {
        id: 'b03363df-35f6-4146-904a-b61fcd7729f2',
        label: 'Manager of Managers',
        categoryId: '7c834864-1f46-4155-b289-0010ed5232f0'
    },
    // EXPERIENCE
    'bdb6620a-99de-4813-aa30-4ae054e498db': {
        id: 'bdb6620a-99de-4813-aa30-4ae054e498db',
        label: 'Less than 2 years',
        categoryId: '2d136189-cd34-48b3-be00-8f4c96d4e966'
    },
    '9985bf56-1a18-443a-ab29-02a0bbf08697': {
        id: '9985bf56-1a18-443a-ab29-02a0bbf08697',
        label: '2\u20135 years',
        categoryId: '2d136189-cd34-48b3-be00-8f4c96d4e966'
    },
    '57415d66-f817-4cba-a55b-0afef83f2611': {
        id: '57415d66-f817-4cba-a55b-0afef83f2611',
        label: '5 or more years',
        categoryId: '2d136189-cd34-48b3-be00-8f4c96d4e966'
    },
    // GOALS
    'a9990629-bdf1-48ea-ad7b-a0da7f181666': {
        id: 'a9990629-bdf1-48ea-ad7b-a0da7f181666',
        label: 'Refine leadership abilities',
        categoryId: '08636b4a-ff37-4b01-8af3-17e68ebd7be2'
    },
    'a1f9c299-a495-46f5-bd91-3a3719dd53e4': {
        id: 'a1f9c299-a495-46f5-bd91-3a3719dd53e4',
        label: 'Become a supervisor or manager',
        categoryId: '08636b4a-ff37-4b01-8af3-17e68ebd7be2'
    },
    '75fc2018-11c7-4a46-a9ff-b299b26f4d29': {
        id: '75fc2018-11c7-4a46-a9ff-b299b26f4d29',
        label: 'Grow into senior leadership',
        categoryId: '08636b4a-ff37-4b01-8af3-17e68ebd7be2'
    }
};

export const CUSTOM_HOME_ROW_TYPES_OBJECT = {
    // GLOBAL_CONTENT_ROW: {
    //     value: 'GLOBAL_CONTENT_ROW',
    //     label: 'Global Collection Row',
    //     message: ''
    // },
    IMPROVE_YOUR_COMMUNICATION: {
        value: 'IMPROVE_YOUR_COMMUNICATION',
        label: 'Default Row',
        message: 'This default row cannot be changed or removed.'
    },
    THINK_LIKE_A_LEADER: {
        value: 'THINK_LIKE_A_LEADER',
        label: 'Default Row',
        message: 'This default row cannot be changed or removed.'
    },
    ESSENTIAL_MANAGER_SKILLS: {
        value: 'ESSENTIAL_MANAGER_SKILLS',
        label: 'Default Row',
        message: 'This default row cannot be changed or removed.'
    },
    POPULAR_ON_PATHS: {
        value: 'POPULAR_ON_PATHS',
        label: 'Default Row',
        message: 'This default row cannot be changed or removed.'
    },
    COLLECTION: {
        value: 'COLLECTION',
        label: 'Custom Row',
        message: ''
    }
    // FEATURED_COLLECTION: {
    //     value: 'FEATURED_COLLECTION',
    //     label: 'Featured Collection',
    //     message: `Verb learners will see the featured collection for the user's company.`
    // },
    // PRESET_JUST_RELEASED: {
    //     value: 'PRESET_JUST_RELEASED',
    //     label: 'Newly Released',
    //     message: `This row is not configurable. Verb learners will see a row with four recently published collections that are available to the user.`
    // },
    // PRESET_DIMENSIONS_SECTION: {
    //     value: 'PRESET_DIMENSIONS_SECTION',
    //     // label: 'Dimensions of Whole-Person Development',
    //     label: 'Human-centered Leadership Development',
    //     message:
    //         'This section is not configurable. Verb learners will see a section with the dimensions in the Verb Learning Framework. If the user’s company has a custom framework, they will see the dimensions in their custom framework.'
    // },
    // RECOMMENDED_COLLECTIONS: {
    //     value: 'RECOMMENDED_COLLECTIONS',
    //     label: 'Assigned and Recommended Collections',
    //     message: `This row is not configurable. Verb learners will see a row with all collections that have been recommended to them.`
    // },
    // IN_PROGRESS_SECTION: {
    //     value: 'IN_PROGRESS_SECTION',
    //     label: 'In Progress Collections',
    //     message: `This row is not configurable. Verb learners will see a row with all collections that they are currently working on.`
    // },
    // TEAMS_SECTION: {
    //     value: 'TEAMS_SECTION',
    //     label: 'Teams',
    //     message: `This row is not configurable. Verb learners will see a row with the first two teams they joined.`
    // },
    // COMPLETED_COLLECTIONS: {
    //     value: 'COMPLETED_COLLECTIONS',
    //     label: 'Completed Collections',
    //     message: `This row is not configurable. Verb learners will see a row with all collections that they have completed.`
    // }
};

export const DEFAULT_CUSTOM_HOME_PAGE = {
    categories: [
        {
            label: 'Human-centered Leadership Development',
            subtext: '',
            type: 'PRESET_DIMENSIONS_SECTION',
            content: []
        },
        {
            label: 'Assigned and Recommended Collections',
            subtext: '',
            type: 'RECOMMENDED_COLLECTIONS',
            content: []
        },
        {
            label: 'Teams',
            subtext: '',
            type: 'TEAMS_SECTION',
            content: []
        },
        {
            label: 'In Progress Collections',
            subtext: '',
            type: 'IN_PROGRESS_SECTION',
            content: []
        },
        {
            label: 'Completed Collections',
            subtext: '',
            type: 'COMPLETED_COLLECTIONS',
            content: []
        }
    ]
};

export const POPULAR_ON_PATHS_ROW = {
    label: 'Popular on Paths',
    subtext: '',
    type: 'POPULAR_ON_PATHS',
    content: [
        {
            id: '67ab65431b07a97b4f1d47e9',
            order: 1
        },
        {
           id: '649b38ed8805fc00114cb0fd',
           order: 2
        },
        {
           id: '5e6a6eb936dc040011bd14c3',
           order: 3
        },
        {
           id: '654aa95f7560192049e0649e',
           order: 4
        },
        {
           id: '63a0a22f5ce23900118cc2ad',
           order: 5
        }
        
    ]
}

export const DEFAULT_CUSTOM_DISCOVER_PAGE = {
    categories: [
        // {
        //     label: 'Assigned and Recommended Collections',
        //     subtext: '',
        //     type: 'RECOMMENDED_COLLECTIONS',
        //     content: []
        // },
        // {
        //     label: 'Teams',
        //     subtext: '',
        //     type: 'TEAMS_SECTION',
        //     content: []
        // },
        // {
        //     label: 'Newly Released',
        //     subtext: '',
        //     type: 'PRESET_JUST_RELEASED',
        //     content: []
        // },
        {
            label: 'Improve Your Communication',
            subtext: '',
            type: 'IMPROVE_YOUR_COMMUNICATION',
            content: [
                '5e6a6eb936dc040011bd14c3',
                '6425bec82a22290012718a34',
                '5cb6262529424f00109aecca',
                '6499a6d58805fc00114cad17'
            ]
        },
        {
            label: 'Think Like a Leader',
            subtext: '',
            type: 'THINK_LIKE_A_LEADER',
            content: [
                '61b11d04f944510011d8f240',
                '5e6bb5b714195a00145a9aba',
                '6499b49ba11a65001255e987',
                '644a6670c91f0e0012c84854'
            ]
        },
        {
            label: 'Essential Manager Skills',
            subtext: '',
            type: 'ESSENTIAL_MANAGER_SKILLS',
            content: [
                '67ab65431b07a97b4f1d47e9',
                '6323acb00686980014051b32',
                '620c36082073fd00112f5c35',
                '6499d00aa11a65001255e98c',
                '6215328bf09d5400141649ce'
            ],
            isOrderLocked: true,
        }
    ]
};

export const TEAM_RESOURCE_TYPES = {
    REFERENCE_FILE: {
        value: 'REFERENCE_FILE',
        label: 'Reference File'
    },
    DISCUSSION_GUIDE: {
        value: 'DISCUSSION_GUIDE',
        label: 'Discussion Guide'
    },
    WORKSHEET: {
        value: 'WORKSHEET',
        label: 'Worksheet'
    },
    TEMPLATE: {
        value: 'TEMPLATE',
        label: 'Template'
    }
};

export const TEAM_RESOURCE_PERMISSION_TYPES = {
    WHOLE_TEAM: {
        value: 'WHOLE_TEAM',
        label: 'Whole Team'
    },
    TEAM_LEAD_ONLY: {
        value: 'TEAM_LEAD_ONLY',
        label: 'Team Lead Only'
    }
};


export const MEDIA_LIBRARY_URL_REGEX = /(https:\/\/api(.dev|.demo|.app).verb.net\/media\/file)|(http:\/\/localhost:8081\/media\/file)|(https:\/\/hcm(-quarterly|-dev|-rc|-internal|-demo|-performance)?.paycor.com\/paths\/paths-sls-api-v2\/media\/file)/g;

export const PRACTICAL_APP_OVERLAYS = {
    PRACTICAL_APP_IN_PROGRESS: 'PRACTICAL_APP_IN_PROGRESS',
    REFLECTION_IN_PROGRESS: 'REFLECTION_IN_PROGRESS'
};

export const ERROR_MSG = {
    EMAIL: 'Invalid Email Format'
};

export const MODAL_VALIDATION = {
    pathwayNotViewabletoLearners: {
        messageTextProp: {
            messageId: 'PATHWAY_NOT_VIEWABLE',
            defaultMessage:
                'You are about to leave this page but your pathway isn’t viewable be any learners yet.{space}Do you want to leave?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_AND_EXIT',
            defaultMessage: 'SAVE & EXIT'
        }
    },
    assignPathwayOverFeaturedContent: {
        messageTextProp: {
            messageId: 'ASSIGN_OVER_FEATURED_TEAM_CONTENT',
            defaultMessage:
                'Assigning this pathway will replace any currently assigned collection or pathway for this Team or Group.{space} Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    leaveWithoutSaving: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING',
            defaultMessage:
                'You are about to leave this page without saving, any changes to this page will be lost.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    leaveWithoutSavingSummary: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING_SUMMARY',
            defaultMessage:
                'You are about to leave without saving any changes to the pathway summary page.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    leaveWithoutSavingGlobalRelease: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING_RELEASE',
            defaultMessage:
                'You are about to leave without saving any changes to the global release page.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    leaveWithoutSavingMilestonesAssign: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING_MILESTONES_ASSIGN',
            defaultMessage:
                'You are about to leave this page without saving. Any changes to both the milestones and assign pages will be lost.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    leaveWithoutSavingMilestones: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING_MILESTONES',
            defaultMessage:
                'You are about to leave without saving any changes to the pathway milestones page.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    leaveWithoutSavingAssign: {
        messageTextProp: {
            messageId: 'LEAVE_WITHOUT_SAVING_ASSIGN',
            defaultMessage:
                'You are about to leave without saving any changes to the pathway assign page.{space}Do you want to leave without saving?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'LEAVE_NO_SAVE',
            defaultMessage: 'LEAVE WITHOUT SAVING'
        }
    },
    removePathwayFromTeam: {
        messageTextProp: {
            messageId: 'REMOVE_PATHWAY_FROM_TEAM',
            defaultMessage:
                'Removing this pathway will remove it from the team or group space.{space}Any learner who has already been assigned or started this pathway will be able to access it from the side panel on their homepage.{space}Do you want to remove this pathway?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'REMOVE_PATHWAY',
            defaultMessage: 'REMOVE PATHWAY'
        }
    },
    saveExitMilestoneChanges: {
        messageTextProp: {
            messageId: 'SAVE_AND_EXIT_MILESTONE_CHANGES',
            defaultMessage:
                'Saving these changes will modify the milestones for all learners working on this pathway. {space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_AND_EXIT',
            defaultMessage: 'SAVE & EXIT'
        }
    },
    saveMilestoneChanges: {
        messageTextProp: {
            messageId: 'SAVE_MILESTONE_CHANGES',
            defaultMessage:
                'Saving these changes will modify the milestones for all learners working on this pathway. {space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    copyConfirmation: {
        messageTextProp: {
            messageId: 'COPY_PATHWAY_CONFIRMATION',
            defaultMessage:
                'Copying a Pathway will copy the Summary and Milestones but not the Assigned page.{space}Do you want to make a copy?'
        },
        cancelButtonProp: {
            textId: 'CANCEL',
            defaultMessage: 'CANCEL'
        },
        actionButtonProp: {
            textId: 'MAKE_A_COPY',
            defaultMessage: 'MAKE A COPY'
        }
    },
    copyConfirmationAssignTab: {
        messageTextProp: {
            messageId: 'COPY_PATHWAY_CONFIRMATION_ASSIGN',
            defaultMessage:
                'Copying a Pathway will copy the Summary and Milestones but not the Assigned page.{space}Do you want to make a copy?'
        },
        cancelButtonProp: {
            textId: 'CANCEL',
            defaultMessage: 'CANCEL'
        },
        actionButtonProp: {
            textId: 'MAKE_A_COPY',
            defaultMessage: 'MAKE A COPY'
        }
    },
    copyErrorDuplicateName: {
        messageTextProp: {
            messageId: 'COPY_PATHWAY_ERROR_DUPLICATE_NAME',
            defaultMessage:
                'A copy of this pathway already exists. Please edit the already existing copy or rename the copy you are trying to create.'
        },
        actionButtonProp: {
            textId: 'OK',
            defaultMessage: 'OK'
        }
    },
    pathwayReleaseConfirmation: {
        messageTextProp: {
            messageId: 'PATHWAY_RELEASE_CONFIRMATION',
            defaultMessage:
                'Releasing this pathway will allow all companies across Verb to utilize it via the pathway panel on the homepage.{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    pathwayDeactivateConfirmation: {
        messageTextProp: {
            messageId: 'PATHWAY_DEACTIVATE_CONFIRMATION',
            defaultMessage:
                'You are about to deactivate this pathway for all external companies across Verb. Access to this pathway for all external learners will immediately be removed and the will no longer be able to continue their progress.{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    pathwayActiveToAllMilestoneWarning: {
        messageTextProp: {
            messageId: 'ACTIVE_TO_ALL_PATHWAY_MILESTONE_WARNING',
            importantMessage:
                'Due dates for this pathway will need to be updated for any team or group for which it has already been assigned on the Assign page.',
            defaultMessage:
                'The milestone(s) that you have changed will impact any learner who has already been assigned or started this pathway including other companies outside of Verb.{important}{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_AND_CONTINUE',
            defaultMessage: 'SAVE & CONTINUE'
        }
    },
    pathwayActiveToAllSaveMilestoneChangesWarning: {
        messageTextProp: {
            messageId: 'ACTIVE_TO_ALL_PATHWAY_MILESTONE_CHANGES_WARNING',
            importantMessage:
                'Due dates for this pathway will need to be updated for any team or group for which it has already been assigned on the Assign page.',
            defaultMessage:
                'The milestone(s) that you have changed will impact any learner who has already been assigned or started this pathway including other companies outside of Verb.{important}{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    deletePathwayWarning: {
        messageTextProp: {
            messageId: 'DELETE_PATHWAY_WARNING',
            defaultMessage:
                'Deleting this pathway removes it and all of its data from Verb. Learners will no longer be able to work on this pathway and any progress will be lost. {space} Do you want to delete this pathway?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'DELETE_PATHWAY',
            defaultMessage: 'DELETE PATHWAY'
        }
    },
    milestoneChangesWarning: {
        messageTextProp: {
            messageId: 'MILESTONE_CHANGES_WARNING',
            importantMessage:
                'Due dates for this pathway will need to be updated for any team or group for which it has already been assigned on the Assign page.',
            defaultMessage:
                'The milestone(s) that you have changed will impact any learner who has already been assigned or started this pathway.{important}{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    milestoneDeletedWarning: {
        messageTextProp: {
            messageId: 'MILESTONE_DELETED_WARNING',
            defaultMessage:
                'The milestone(s) that you have deleted will be removed from this pathway for any learner who has already been assigned or started this pathway.{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_CHANGES',
            defaultMessage: 'SAVE CHANGES'
        }
    },
    pathwayActiveToAllMilestoneDeletedWarning: {
        messageTextProp: {
            messageId: 'ACTIVE_TO_ALL_PATHWAY_MILESTONE_DELETED_WARNING',
            defaultMessage:
                'The milestone(s) that you have deleted will be removed from this pathway for any learner who has already been assigned or started this pathway including other companies outside of Verb.{space}Do you want to save your changes?'
        },
        cancelButtonProp: {
            textId: 'GO_BACK_BUTTON',
            defaultMessage: 'GO BACK'
        },
        actionButtonProp: {
            textId: 'SAVE_AND_CONTINUE',
            defaultMessage: 'SAVE & CONTINUE'
        }
    }
};

export const DEFAULT_EXPLORE_COLLECTIONS = {
    '6499d00aa11a65001255e98c': 0, // Agree to Get It Done
    '64ecf06743092f0669683102': 1, // Coaching Basics
    '654eacfe7560192049e064e5': 2, // Toolkit: Productivity
    '6323acb00686980014051b32': 3, // Formula for Feedback
};

export const DIMENSION_QUERY_DICTIONARY = {
    manager: "66e99b8078ae3cca3e869d8b",
    communication: "66e99ef478ae3cca3e869d95",
    feedback: "66e9a03878ae3cca3e869d97",
    conflict: "66e9a04a5cca9aa8ff3eef8f",
    productivity: "66e9a0585cca9aa8ff3eef90",
    teamwork: "66e9a0655cca9aa8ff3eef91",
    all: "66e9a75478ae3cca3e869da7",
    toolkits: "66eadcd45cca9aa8ff3eefd3",
}